// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  close: () => 'ปิด',
  error: () => 'ข้อผิดพลาด',
  warn: () => 'คำเตือน',
  info: () => 'ข้อมูล',
  confirmation: () => 'การยืนยัน',
  progressIndeterminate: () => 'กำลังดำเนินการ',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'ระหว่าง ' + p['FROM_SECTION'] + ' ถึง ' + p['TO_SECTION'],
  indexer_disabledLabel: (p: { SECTION: string }) => p['SECTION'] + ' ไม่พบส่วนที่ตรงกัน',
  indexer_othersLabel: () => '#',
  indexer_keyboardInstructionText: () => 'กด Enter เพื่อเลือกค่า',
  indexer_touchInstructionText: () =>
    'แตะสองครั้งและกดค้างไว้เพื่อเข้าสู่โหมดการวาดนิ้ว จากนั้นลากขึ้นหรือลงเพื่อปรับค่า',
  inputPassword_show: () => 'แสดงรหัสผ่าน',
  inputPassword_hide: () => 'ซ่อนรหัสผ่าน',
  inputPassword_hidden: () => 'ซ่อนรหัสผ่านแล้ว',
  formControl_clear: () => 'ล้างข้อมูล',
  formControl_loading: () => 'กำลังโหลด',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'เกินความยาวสูงสุด ' + p['MAX_LENGTH'],
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    'เหลืออักขระ ' + p['CHARACTER_COUNT'] + ' ตัว',
  formControl_requiredMessageDetail: () => 'ป้อนค่า',
  select_requiredMessageDetail: () => 'เลือกค่า',
  select_noMatchesFound: () => 'ไม่พบรายการที่ค้นหา',
  select_oneMatchFound: () => 'พบข้อมูลหนึ่งรายการ',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'พบรายการที่ค้นหา ' + p['TOTAL_SIZE'] + ' รายการ',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'พบรายการที่ค้นหาตั้งแต่ ' + p['TOTAL_SIZE'] + ' รายการ',
  selectMultiple_selectedValues: () => 'ค่าที่เลือกไว้',
  selectMultiple_showSelectedValues: () => 'แสดงเฉพาะค่าที่เลือกเท่านั้น',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    'เลือกค่า ' + p['VALUE_COUNT'] + ' ค่าแล้ว',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'กด Backspace หรือ Delete เพื่อย้ายค่าที่เลือกออก',
  selectMultiple_apply: () => 'ใช้',
  selectMultiple_back: () => 'ย้อนกลับ',
  selector_selected: () => 'เลือกช่องทำเครื่องหมายแล้ว',
  selector_unselected: () => 'ไม่ได้เลือกช่องทำเครื่องหมาย',
  userAssistance_learnMore: () => 'ข้อมูลเพิ่มเติม',
  userAssistance_required: () => 'จำเป็น',
  filePicker_singleFileUploadError: () => 'อัปโหลดครั้งละไฟล์',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'คุณไม่สามารถอัปโหลดไฟล์ประเภท ' + p['fileType'] + ' ได้',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'คุณไม่สามารถอัปโหลดไฟล์ประเภท: ' + p['fileTypes'] + ' ได้',
  filePicker_unknownFileTypeUploadError: () => 'ไม่รู้จัก',
  filePicker_dropzonePrimaryText: () => 'ลากและวาง',
  filePicker_dropzoneSecondaryText: () => 'เลือกไฟล์หรือวางไว้ที่นี่',
  filePicker_dropzoneSecondaryTextMultiple: () => 'เลือกหรือวางไฟล์ไว้ที่นี่',
  filePicker_addFiles: () => 'เพิ่มไฟล์',
  plural_separator: () => ', ',
  inputNumber_increase: () => 'เพิ่ม',
  inputNumber_decrease: () => 'ลด',
  inputNumber_converterParseError: () => 'ป้อนตัวเลข',
  noData_message: () => 'ไม่มีรายการที่จะแสดงผล',
  message_navigationFromMessagesRegion: () =>
    'กำลังเข้าสู่พื้นที่ข้อความ กด F6 เพื่อนาวิเกตกลับไปยังอีลิเมนต์ที่โฟกัสก่อนหน้า',
  message_navigationToMessagesRegion: () =>
    'พื้นที่ข้อความมีข้อความใหม่ กด F6 เพื่อนาวิเกตไปยังพื้นที่ข้อความล่าสุด',
  messageToast_allMessagesClosed: () => 'ข้อความป็อปอัพทั้งหมดจะถูกปิด',
  expandableList_groupCollapse: () => 'ยุบแล้ว',
  expandableList_groupExpand: () => 'ขยายแล้ว',
  expandableList_expandCollapseInstructionText: () => 'ใช้ปุ่มลูกศรเพื่อขยายและยุบ',
  list_suggestion: () => 'ข้อแนะนำ',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'ขั้นตอนที่ ' + p['currentStep'] + ' จาก ' + p['numberOfSteps'],
  train_current: () => 'ปัจจุบัน',
  train_visited: () => 'เข้าดูแล้ว',
  train_not_visited: () => 'ไม่ได้เข้าดู',
  train_message_type: () => 'ประเภทข้อความ',
  viz_drillable: () => 'ดริลล์ได้',
  dataVisualization_stateSelected: () => 'เลือกไว้',
  dataVisualization_stateUnselected: () => 'ไม่ได้เลือกไว้',
  dataVisualization_noData: () => 'ไม่มีข้อมูลที่จะแสดงผล'
};
export default bundle;
